/* Custom element lifecycle supports Shopify's live section re-rendering. */
(() => {
  if (customElements.get('uq-editorial-slideshow')) return;
  class UQEditorialSlideshow extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-uq-slide]')];
      this.dots = [...this.querySelectorAll('[data-uq-dot]')];
      this.index = 0;
      this.hovered = false;
      this.focused = false;
      this.editorSelected = false;
      this.paused = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-uq-prev]')?.addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-uq-next]')?.addEventListener('click', () => this.go(this.index + 1, true), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true), options));
      this.querySelector('[data-uq-pause]')?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.paintPause();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', () => this.schedule(), options);
      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-uq-slide]');
        if (!slide || !this.contains(slide)) return;
        this.editorSelected = true;
        this.go(this.slides.indexOf(slide), true);
      }, options);
      document.addEventListener('shopify:block:deselect', (event) => {
        if (this.contains(event.target)) { this.editorSelected = false; this.schedule(); }
      }, options);
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) { this.editorSelected = true; this.schedule(); }
      }, options);
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.target.contains(this)) { this.editorSelected = false; this.schedule(); }
      }, options);
      this.go(0);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
    }
    paintPause() {
      const button = this.querySelector('[data-uq-pause]');
      if (!button) return;
      button.setAttribute('aria-pressed', String(this.paused));
      button.setAttribute('aria-label', this.paused ? button.dataset.playLabel : button.dataset.pauseLabel);
      button.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
    }
    go(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      const status = this.querySelector('[data-uq-slide-status]');
      if (announce && status) status.textContent = this.slides[this.index].getAttribute('aria-label');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.editorSelected || document.hidden || this.reducedMotion.matches || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 7000);
    }
  }
  customElements.define('uq-editorial-slideshow', UQEditorialSlideshow);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || document.querySelector('.uq-header .uq-nav-disclosure[open]')) return;
    document.querySelectorAll('.uq-header.is-nav-open').forEach((header) => {
      header.classList.remove('is-nav-open');
      const toggle = header.querySelector('.uq-header__burger');
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.uq-header.is-nav-open').forEach((header) => {
      if (header.contains(event.target) && !event.target.closest('.uq-header__nav a')) return;
      header.classList.remove('is-nav-open');
      header.querySelector('.uq-header__burger')?.setAttribute('aria-expanded', 'false');
    });
  });
})();
